export default {"src":"/_next/static/media/sold.a5c00f10.svg","height":261,"width":280,"blurWidth":0,"blurHeight":0};